<div class="order-detail">
  <h4>{{ title }}</h4>
  <ul>
    @for (i of data; track $index) {
      <li>
        @if (i.icon) {
          <mat-icon [inline]="true">{{ i.icon }}</mat-icon>
        }
        <span class="info-title">
          {{ i.title }}
        </span>
        @if (i.type !== 'date') {
          <span class="info-value">{{ i.value }}</span>
        } @else {
          <span class="info-value">{{ i.value | date: 'yyyy-MM-dd' }}</span>
        }
      </li>
    }
  </ul>
</div>
